import { useState } from "react";
import {
    Box,
    Tabs,
    Tab,
    Typography,
    Paper,
    Grid,
} from "@mui/material";
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import TopNavBar from "../../components/TopNavBar/DefaultNavBar";
import MDBox from "../../components/MDBox";
import MDTypography from "../../components/MDTypography";
import UserManagement from "./tabs/UserManagement";
import RolePermissions from "./tabs/RolePermissions";
import AIPrompts from "./tabs/AIPrompts";
import SystemHealth from "./tabs/SystemHealth";

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`admin-tabpanel-${index}`}
            aria-labelledby={`admin-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    {children}
                </Box>
            )}
        </div>
    );
}

function a11yProps(index) {
    return {
        id: `admin-tab-${index}`,
        'aria-controls': `admin-tabpanel-${index}`,
    };
}

function AdminPage() {
    const [tabValue, setTabValue] = useState(0);

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };

    return (
        <DashboardLayout>
            <TopNavBar />
            <MDBox>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper sx={{ p: 2, bgcolor: 'navy.main' }}>
                            <MDTypography variant="h4" gutterBottom>
                                Admin Dashboard
                            </MDTypography>
                            <MDBox bgColor="slate_gray" sx={{ width: '100%', borderRadius: 2 }}>
                                <MDBox sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                    <Tabs 
                                        value={tabValue} 
                                        onChange={handleTabChange}
                                    >
                                        <Tab 
                                            label={<Typography variant="text1">User Management</Typography>} 
                                            {...a11yProps(0)} 
                                        />
                                        <Tab 
                                            label={<Typography variant="text1">Role Permissions</Typography>} 
                                            {...a11yProps(1)} 
                                        />
                                        <Tab 
                                            label={<Typography variant="text1">AI Prompts</Typography>} 
                                            {...a11yProps(2)} 
                                        />
                                        <Tab 
                                            label={<Typography variant="text1">System Health</Typography>} 
                                            {...a11yProps(3)} 
                                        />
                                    </Tabs>
                                </MDBox>
                                <TabPanel value={tabValue} index={0}>
                                    <UserManagement />
                                </TabPanel>
                                <TabPanel value={tabValue} index={1}>
                                    <RolePermissions />
                                </TabPanel>
                                <TabPanel value={tabValue} index={2}>
                                    <AIPrompts />
                                </TabPanel>
                                <TabPanel value={tabValue} index={3}>
                                    <SystemHealth />
                                </TabPanel>
                            </MDBox>
                        </Paper>
                    </Grid>
                </Grid>
            </MDBox>
        </DashboardLayout>
    );
}

export default AdminPage;